@if (authService.loginUser() != null) {
  <mat-nav-list>

    @if (authService.loginUser()?.isAdmin) {
      <a mat-list-item routerLink="/dashboard" (click)="onClick()">
        <div class="link-item">
          <mat-icon>dashboard</mat-icon>
          <span class="menu-text">{{ 'navigation.dashboard' | transloco }}</span>
        </div>
      </a>
    }

    <a mat-list-item routerLink="/import" (click)="onClick()">
      <div class="link-item">
        <mat-icon>upload</mat-icon>
        <span class="menu-text">{{ 'navigation.import' | transloco }}</span>
      </div>
    </a>

    @if (authService.loginUser()?.isAdmin) {
      <a mat-list-item routerLink="/measurements" (click)="onClick()">
        <div class="link-item">
          <mat-icon>bar_chart</mat-icon>
          <span class="menu-text">{{ 'navigation.quality' | transloco }}</span>
        </div>
      </a>

      <a mat-list-item routerLink="/productiondata" (click)="onClick()">
        <div class="link-item">
          <mat-icon>factory</mat-icon>
          <span class="menu-text">{{ 'navigation.production' | transloco }}</span>
        </div>
      </a>

      <a mat-list-item routerLink="/mould-configurations" (click)="onClick()">
        <div class="link-item">
          <mat-icon>settings</mat-icon>
          <span class="menu-text">{{ 'navigation.configuration' | transloco }}</span>
        </div>
      </a>

      <a mat-list-item routerLink="/monthly-report" (click)="onClick()">
        <div class="link-item">
          <mat-icon>pie_chart</mat-icon>
          <span class="menu-text">{{ 'navigation.monthlyReport' | transloco }}</span>
        </div>
      </a>

      <a mat-list-item routerLink="/users" (click)="onClick()">
        <div class="link-item">
          <mat-icon>people</mat-icon>
          <span class="menu-text">{{ 'users.navBar' | transloco }}</span>
        </div>
      </a>
    
      <a mat-list-item routerLink="/file-management" (click)="onClick()">
    <div class="link-item">
      <mat-icon>snippet_folder</mat-icon>
      <span class="menu-text">{{ 'navigation.fileManagement' | transloco }}</span>
    </div>
  </a>
}
  </mat-nav-list>
}